// extracted by mini-css-extract-plugin
export default {"shadowed":"Others_shadowed__XW34p","pink":"Others_pink__vDc1q","green":"Others_green__j1zfh","skills":"Others_skills__z6sQL"};